/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import * as React from 'react'
import styles from './index.module.css'

export interface IViewProps {
  children?: React.ReactNode
  flex?: boolean
  [key: string]: any
}

export interface IClassProps {
  flex?: boolean
  center?: boolean
  newStyles?: object
  newCss?: string
}

const calculateClass = (init: string, props: IClassProps) => {
  let additional = ''
  if (props.flex) additional += ` ${styles.fullFlex}`
  if (props.center) additional += ` ${styles.center}`
  if (props.newCss) additional += ` ${props.newCss}`

  return `${init}${additional}`
}

export function View ({ children, newStyles, ...restProps }: IViewProps) {
  return (
    <div
      className={calculateClass(styles.flex, restProps)}
      css={newStyles}
      {...restProps}
    >
      {children}
    </div>
  )
}

export function RView ({ children, newStyles, ...restProps }: IViewProps) {
  return (
    <div
      className={calculateClass(styles.flex_row, restProps)}
      css={newStyles}
      {...restProps}
    >
      {children}
    </div>
  )
}
